<template>
  <div>
    <div class="w-full flex mb-4">
      <report-date-picker v-model="dateRange" @change="getReports"/>
    </div>
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
      <bar-chart class="col-span-2 bg-white overflow-hidden shadow rounded-lg mb-4 p-4"
                 :chart-data="creditsPerMonth"></bar-chart>
      <data-table :entity="'credit'"
                  :columns="tableColumns"
                  :data="creditsToExpire.results"
                  :is-loading="loading"
                  :title="$t('reports.creditsToExpire')"
                  :disablePermissionChecks="true"
                  :goToDetailsOnRowClick="false"
                  operations="refresh"
                  class="col-span-2 mb-4 p-4"
                  ref="table">
        <template v-slot:total="{ row }">
          <strong>{{ row.total }}</strong>
        </template>
      </data-table>
    </div>
  </div>
</template>
<script>
import get from 'lodash/get'
import ReportService from 'src/services/ReportService'
import ReportDatePicker from './ReportDatePicker'
import BarChart from 'src/components/Charts/BarChart'
import { getDefaultRange } from '@/views/admin/reports/defaultReportRange'
import orderBy from 'lodash/orderBy'
export default {
  components: {
    BarChart,
    ReportDatePicker
  },
  data () {
    const year = new Date().getFullYear()
    const defaultRange = getDefaultRange()
    return {
      year,
      defaultRange,
      dateRange: [...defaultRange],
      creditTotals: {
        results: []
      },
      creditsToExpire: {
        results: []
      }
    }
  },
  computed: {
    dateFrom () {
      return get(this.dateRange, '[0]', this.defaultRange[0])
    },
    dateTill () {
      return get(this.dateRange, '[1]', this.defaultRange[1])
    },
    creditsPerMonth () {
      const results = orderBy(this.creditTotals.results, 'date_format', 'asc')
      return {
        labels: results.map(r => this.$formatDate(new Date(this.year, r.date_month - 1, 1), 'MMM')),
        datasets: [
          {
            label: this.$t('reports.creditsOverTime'),
            backgroundColor: '#0695A2',
            data: results.map(r => ({
              x: new Date(this.year, r.date_month - 1, 1),
              y: r.total
            }))
          },
        ]
      }
    },
    tableColumns() {
      return [
        {
          label: this.$t('generic.client'),
          prop: 'client_name'
        },
        {
          label: this.$t('generic.credits'),
          prop: 'total'
        },
        {
          label: this.$t('generic.date'),
          prop: 'date_format'
        },
      ]
    }
  },
  methods: {
    async getCreditReport () {
      const {data} = await ReportService.get({
        model: 'credits',
        group: 'month',
        select: 'id,total',
        date_range: 'custom',
        date_from: this.dateFrom,
        date_till: this.dateTill,
        sort: 'date_month',
      })
      this.creditTotals = data
    },
    async getCreditsToExpire () {
      const {data} = await ReportService.get({
        model: 'credits',
        group: 'client,month',
        select: 'id,total,credits,client,date_day,month',
        date_range: 'custom',
        date_from: this.dateFrom,
        date_till: this.dateTill,
        sort: 'date_month,date_day',
        'where[credits_valid]': true,
      })
      this.creditsToExpire = data
    },
    getReports () {
      this.getCreditReport()
      this.getCreditsToExpire()
    }
  },
  mounted () {
    this.getReports()
  }
}
</script>
<style>
</style>
